import {drawer} from '@cypro/ui/components'
import {BatchDrawer} from './batch-drawer'
import {Batch} from '@cypro/engine/schema'
import {Suspense} from 'react'
import {BatchProvider} from '@/shared/contexts/batch'

export function getBatchDrawerId(batchId: string) {
  return `batch-drawer-${batchId}`
}

export function openBatchDrawer(batch: Batch) {
  const id = getBatchDrawerId(batch.id)

  try {
    drawer.remove(id)
  } catch {}

  return drawer.open(id, {
    id,
    children: (
      <Suspense>
        {batch && (
          <BatchProvider batch={batch}>
            <BatchDrawer />
          </BatchProvider>
        )}
      </Suspense>
    ),
    contentProps: {
      'data-e2e': 'batch-drawer',
    },
  })
}
